import React, { useState } from 'react';
import {
  Typography,
  Sizes,
  Rank,
  Heading,
  TextBoldness,
  getRehydratableName,
  getClassNameFactory,
} from '@dcl/ui';
import { types, boldTypes } from '@dcl/ui/dist/elements/Heading';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import TalkWithUsModal from './components/TalkWithUsModal';
import { ITalkWithUsProps } from './TalkWithUs.types';
import './index.css';
import TalkWithUsIcon from './TalkWithUsIcon';

export const TalkWithUs: React.FC<ITalkWithUsProps> = (props) => {
  const {
    title,
    modalTitle,
    description,
    buttonText,
    isBorderVisible = false,
    phoneSupportInfo,
    phoneSupportInfoInBrackets,
    countries,
    holidays,
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOnClick = () => {
    setIsModalOpen(true);
  };
  const getClassName = getClassNameFactory(TalkWithUs.displayName);
  return (
    <div
      className={getClassName()}
      data-rehydratable={getRehydratableName(TalkWithUs.displayName)}
      {...propsToDataAttributes(props)}
    >
      <div
        className={getClassName({
          descendantName: 'container',
          modifiers: isBorderVisible && 'border',
        })}
      >
        <div
          className={getClassName({
            descendantName: 'textContainer',
            modifiers: isBorderVisible && 'visible',
          })}
        >
          <Heading
            type={types.XtraSmall}
            boldType={boldTypes.black}
            rank={Rank.Second}
            className={getClassName({ descendantName: 'heading' })}
          >
            {title}
          </Heading>
          <Typography
            type={Sizes.XXTRASMALL}
            tag={TypographyTags.P}
            className={getClassName({ descendantName: 'description' })}
          >
            {description}
          </Typography>
        </div>
        <div className={getClassName({ descendantName: 'buttonContainer' })}>
          <button
            className={getClassName({ descendantName: 'button' })}
            onClick={handleOnClick}
          >
            {TalkWithUsIcon}
            <Typography
              type={Sizes.XXTRASMALL}
              tag={TypographyTags.P}
              boldness={TextBoldness.Medium}
              className={getClassName({ descendantName: 'buttonText' })}
            >
              {buttonText}
            </Typography>
          </button>
        </div>
        {isModalOpen && (
          <TalkWithUsModal
            onClose={handleCloseModal}
            holidays={holidays}
            phoneSupportInfo={phoneSupportInfo}
            phoneSupportInfoInBrackets={phoneSupportInfoInBrackets}
            countries={countries}
            modalTitle={modalTitle}
          />
        )}
      </div>
    </div>
  );
};

TalkWithUs.displayName = 'TalkWithUs';
